<template>
  <div>
    <b-row class="match-height" v-if="!loading">
      <b-col md="6" lg="4">
        <b-card :img-src="require('@/assets/images/templates/t1.png')" img-alt="Card image cap" img-top
          title="Template 1" :class="[
            'template-card',
            {
              'selected-card': buttonLabel('template1') === 'Configure',
            },
          ]" @click="selectCard('template1')">
          <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary"
            @click.stop="configureTemplate('template1')">
            {{ buttonLabel('template1') }}
          </b-button>
          <b-button v-if="buttonLabel('template1') === 'Configure'" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary" class="ml-2" @click.stop="previewTemplate()">
            Preview
          </b-button>
        </b-card>
      </b-col>

      <b-col md="6" lg="4">
        <b-card :img-src="require('@/assets/images/templates/t2.png')" img-alt="Card image cap" img-top
          title="Template 2" :class="[
            'template-card',
            {
              'selected-card': buttonLabel('template2') === 'Configure',
            },
          ]" @click="selectCard('template2')">
          <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary"
            @click.stop="configureTemplate('template2')">
            {{ buttonLabel('template2') }}
          </b-button>
          <b-button v-if="buttonLabel('template2') === 'Configure'" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary" class="ml-2" @click.stop="previewTemplate()">
            Preview
          </b-button>
        </b-card>
      </b-col>

      <b-col md="6" lg="4">
        <b-card :img-src="require('@/assets/images/templates/t3.png')" img-alt="Card image cap" img-top
          title="Template 3" :class="[
            'template-card',
            {
              'selected-card': buttonLabel('template3') === 'Configure',
            },
          ]" @click="selectCard('template3')">
          <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary"
            @click.stop="configureTemplate('template3')">
            {{ buttonLabel('template3') }}
          </b-button>
          <b-button v-if="buttonLabel('template3') === 'Configure'" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary" class="ml-2" @click.stop="previewTemplate()">
            Preview
          </b-button>
        </b-card>
      </b-col>
    </b-row>

    <!-- Loader -->
    <div v-else class="loader-container">
      <b-spinner label="Loading..."></b-spinner>
    </div>
  </div>
</template>

<script>
import { BCard, BCardText, BButton, BRow, BCol, BSpinner } from "bootstrap-vue";
import { template } from "lodash";
import Ripple from "vue-ripple-directive";
import { mapActions } from "vuex";
import template1Content from './template1.txt';
import template2Content from './template2.txt';
import template3Content from './template3.txt';


export default {
  components: {
    BCard,
    BCardText,
    BButton,
    BRow,
    BCol,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      tenant: localStorage.getItem("userTenant"),
      selectedCard: null,
      fetchedPageName: null,
      loading: true,
      fetchedId: '',
    };
  },
  methods: {
    ...mapActions("websiteBuilderModule", [
      "getWebsitePageName",
      "updateWebsitebuildersAction",
      "addWebsitebuildersAction"
    ]),
    async fetchPageName() {
      try {
        this.loading = true; // Start loading
        const response = await this.getWebsitePageName();
        if (response && response.result) {
          this.fetchedId = response.result.id;
          this.fetchedPageName = response.result.pageName; // If you also need `pageName`
          console.log("Fetched ID:", this.fetchedId);
          console.log("Fetched Page Name:", this.fetchedPageName);
          this.selectedCard = `${this.fetchedPageName}`;
          console.log("Card:", this.selectedCard);
        } else {
          console.error("Page Name not found in the response.");
        }
      } catch (error) {
        console.error("Error fetching API response:", error);
      } finally {
        this.loading = false; // Stop loading
      }
    },
    buttonLabel(template) {
      // If the fetched page name matches the template, it's already configured
      if (this.fetchedPageName === template) {
        return "Configure";
      } else {
        return "Set up template";
      }
    },
    selectCard(card) {
      this.selectedCard = card;
    },
    async configureTemplate(template) {
      console.log("Selected Template for Configuration:", template);

      if (this.buttonLabel(template) === "Set up template") {
        const result = await this.$swal({
  title: "Are you sure?",
  text: "Changing the template will delete existing data on your website!",
  icon: "warning",
  showCancelButton: true,
  confirmButtonText: "Yes, change it!",
  cancelButtonText: "Cancel",
  customClass: {
    confirmButton: "btn btn-danger swal-confirm-btn",
    cancelButton: "btn btn-secondary swal-cancel-btn",
  },
  buttonsStyling: false,
});


        if (!result.isConfirmed) {
          return;
        }
        try {
          const templateContentMap = {
            template1: template1Content,
            template2: template2Content,
            template3: template3Content,
          };

          const htmlContent = templateContentMap[template];
          if (!htmlContent) throw new Error("Template content not found!");

          console.log('htmlContent', htmlContent);
          const sanitizedContent = htmlContent.replace(/\\/g, '');
          const payload = {
            id: this.fetchedId,
            htmlContent: sanitizedContent,
            isActive: true,
            websiteStatus: "New",
            urlPath: "string",
            pageName: template,
            tenantId: this.tenant
          };
          console.log(payload);
      
            await this.updateWebsitebuildersAction(payload);
     
          this.$swal({
            title: "Template Set!",
            text: "Template has been successfully set up.",
            icon: "success",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          this.$router.push({ name: "configurewebsitebuilder" });
        } catch (error) {
          console.error("Error setting up template:", error);
          this.$swal({
            title: "Error!",
            text: "Failed to set up the template. Please try again.",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        }
      } else {
        this.$router.push({ name: "configurewebsitebuilder" });
      }
    },
    previewTemplate() {
      const baseURL = process.env.VUE_APP_WEBSITE_BUILDER_BASE_URL; // Use the prefixed variable
      if (!baseURL) {
        console.error("Base URL is not defined. Please check your environment variables.");
        return;
      }
      const tenantPath = this.tenant;
      if (!tenantPath) {
        console.error("Tenant is not defined.");
        return;
      }
      const previewURL = `${baseURL}${tenantPath}`;
      console.log('Preview URL:', previewURL);
      window.open(previewURL, "_blank"); // Open in a new tab
    }


  },
  async mounted() {
    this.fetchPageName(); // Fetch the API response on page load
  },
};
</script>

<style>
.template-card {
  border: 2px solid rgba(0, 0, 0, 0);
}

.template-card.selected-card {
  cursor: pointer;
  border: 2px solid #9fc54c;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
}

.template-card img {
  height: 500px;
  object-fit: cover;
  object-position: top;
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;


  
}

.swal-confirm-btn {
  margin-right: 15px !important;
}

.swal-cancel-btn {
  margin-left: 15px !important;
}

</style>
